import { io } from 'socket.io-client';
import { getActiveSubscription } from '@/data/session/session-globals';

export const DOCUMENT_ID_PREFIXES = {
    NOTIFICATIONS: 'notifications',
    DASHBOARD: 'DASHBOARD',
    REPLAY: 'REPLAY',
    IDEAS: 'IDEAS',
    FEEDBACK: 'FEEDBACK',
};

// Holds a map of documentIds and each callback registered to the documentId
const documentIdCallbacks = new Map();
let socket;

// connect to server
export function connectToWebSocketServer ({ dispatch }) {
    if (socket) return;

    const serverUrl = 'wss://local.pendo.io:8888/in-app-commenting';
    const opts = {
        path: '/ws/socket.io',
        transports: ['websocket'],
        forceNew: false,
        autoConnect: false,
    };
    socket = io(serverUrl, opts);
    socket.connect();

    socket.on('connect', () => {
        dispatch('pendoCollaboration/init', null, { root: true });

        // Rejoin rooms on reconnection
        if (documentIdCallbacks.size > 0) {
            for (const documentId of documentIdCallbacks.keys()) {
                socket.emit('join', documentId);
            }
        }

    });

    socket.on('connect_error', () => {
        dispatch('pendoCollaboration/teardown', null, { root: true });
    });

    socket.on('disconnect', (reason) => {
        dispatch('pendoCollaboration/teardown', null, { root: true });
        // socket.io won't auto-reconnect for these reasons
        if (reason === 'io server disconnect' || reason === 'io client disconnect') {
            socket = null;
            documentIdCallbacks.clear();
        }
        // For transport errors/timeouts, socket.io reconnects automatically
        // and the 'connect' handler will rejoin rooms
    });

    socket.on('message', ({ documentId, ...payload }) => {
        documentIdCallbacks.get(documentId)?.forEach((cb) => cb(payload));
    });
}

export function subscribeToCommentsStream ({ documentId, callback }) {
    if (!socket) return () => {};

    // Join the room if not already subscribed
    if (!documentIdCallbacks.has(documentId)) {
        documentIdCallbacks.set(documentId, new Set());
        socket.emit('join', documentId);
    }

    documentIdCallbacks.get(documentId).add(callback);

    // Return unsubscribe function
    return function unsubscribe () {
        const callbacks = documentIdCallbacks.get(documentId);
        if (!callbacks) return;
        callbacks.delete(callback);
        if (callbacks.size === 0) {
            documentIdCallbacks.delete(documentId);
            socket?.emit('leave', documentId);
        }
    };
}

export function createThread ({ documentId, targetElementId, textBody }) {
    const subId = getActiveSubscription()?.id;
    socket?.emit('createThread', { subId, documentId, targetElementId, textBody });
}

export function addComment ({ documentId, textBody, threadId }) {
    const subId = getActiveSubscription()?.id;
    socket?.emit('addComment', { subId, documentId, textBody, threadId });
}
